export const faqs = [
  {
    question: 'What support options exist?',
    answer: (
      <div>
        Enterprise accounts receive dedicated support. For developer tier, please go to{' '}
        <a href="https://discord.gg/fireworks-ai" target="__blank" className="text-primary-400">
          Discord
        </a>{' '}
        to interact directly with the team and community
      </div>
    ),
  },
  {
    question: 'How much does FireFunction cost?',
    answer: 'FireFunction function calling is currently in an experimental alpha stage, usage is 100% free.',
  },
  {
    question: 'What would my enterprise pricing be?',
    answer: 'Please contact us at inquiries@fireworks.ai for a custom quote.',
  },
];
